import { render } from "./PointView.vue?vue&type=template&id=2b2bd122&scoped=true"
import script from "./PointView.vue?vue&type=script&lang=js"
export * from "./PointView.vue?vue&type=script&lang=js"

import "./PointView.vue?vue&type=style&index=0&id=2b2bd122&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2bd122"]])

export default __exports__